<template>
  <div class="divide-y divide-gray-200">
    <div>
      <apexchart
        ref="chart"
        width="100%"
        height="240"
        type="area"
        :options="options"
        :series="series"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    metric: {
      type: Object,
      required: true,
    },
    values: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    options() {
      return {
        chart: {
          id: 'area-chart',
          zoom: {
            enabled: false,
          },
        },
        stroke: {
          curve: 'smooth',
        },
        xaxis: {
          type: 'datetime',
          tickAmount: 7,
        },
        yaxis: {
          labels: {
            minWidth: 40,
            maxWidth: 40,
          },
        },
        dataLabels: {
          enabled: false,
        },
      };
    },
    series() {
      return [
        {
          name: this.metric.title,
          data: this.values.map(({ date, value }) => ({
            x: new Date(date).getTime(),
            y: value,
          })),
        },
      ];
    },
  },
  beforeDestroy() {
    this.$refs.chart.destroy();
  },
};
</script>
